import { render, staticRenderFns } from "./StatsResult.vue?vue&type=template&id=881ed67a&scoped=true"
import script from "./StatsResult.vue?vue&type=script&lang=js"
export * from "./StatsResult.vue?vue&type=script&lang=js"
import style0 from "./StatsResult.vue?vue&type=style&index=0&id=881ed67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881ed67a",
  null
  
)

export default component.exports